var _circle, _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.001,
    height: 242.89,
    viewBox: "0 0 200.001 242.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25684",
    "data-name": "Grupo 25684",
    transform: "translate(-859.585 -297.922)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2285",
    "data-name": "Elipse 2285",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(859.586 326.281)",
    fill: "#e5f4f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-24",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 618.436, 126.967)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69584",
    "data-name": "Trazado 69584",
    d: "M457.425,202.728H438.081V143.392a41.149,41.149,0,0,0-82.3,0v59.335H336.44V143.392a60.492,60.492,0,0,1,120.985,0Z",
    transform: "translate(14.692 0)",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25683",
    "data-name": "Grupo 25683",
    transform: "translate(351.132 82.9)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69585",
    "data-name": "Trazado 69585",
    d: "M457.425,202.728H438.081V143.392a41.149,41.149,0,0,0-82.3,0v59.335H336.44V143.392a60.492,60.492,0,0,1,120.985,0Z",
    transform: "translate(-336.44 -82.9)",
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69586",
    "data-name": "Trazado 69586",
    d: "M494.278,125.674v97.1A11.272,11.272,0,0,1,483,234.05H340.184a11.245,11.245,0,0,1-11.214-11.274h0v-97.1A11.245,11.245,0,0,1,340.184,114.4H483a10.84,10.84,0,0,1,5.34,1.365A11.187,11.187,0,0,1,494.278,125.674Z",
    transform: "translate(0 61.953)",
    fill: "#003763"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69587",
    "data-name": "Trazado 69587",
    d: "M488.345,115.765v95.144A11.245,11.245,0,0,1,477.1,222.153H334.251a10.976,10.976,0,0,1-5.281-1.335V125.674A11.245,11.245,0,0,1,340.184,114.4H483A10.84,10.84,0,0,1,488.345,115.765Z",
    transform: "translate(0 61.953)",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69588",
    "data-name": "Trazado 69588",
    d: "M392.2,144.364A21.272,21.272,0,1,0,363.514,164.6l-.979,25.87h17L377.013,165.1A21.567,21.567,0,0,0,392.2,144.364Z",
    transform: "translate(40.693 79.635)",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandado);
export default __webpack_public_path__ + "static/media/Candado.39a8f38ba0b0090769a5c6477d52b33a.svg";
export { ForwardRef as ReactComponent };